// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NE5Ep","logo":"styles_logo__aNXf1","name":"styles_name__G9CIZ"};